import CardImageLogo from '@/components/atoms/card-image-logo/cardImageLogo';
import './cardPaymentMethods.scss';

const CardPaymentMethods = ({ content }: any) => {
  return (
    <div className="m-cardPaymentMethods__container">
      <div className="m-cardPaymentMethods__container__header">
        <h3>{content.nombre}</h3>
        <p>{content.subtitulo}</p>
      </div>
      <div className="m-cardPaymentMethods__container__line" />
      <CardImageLogo content={content.referencias} />
    </div>
  );
};

export default CardPaymentMethods;
